import { type UserList, getUserName } from 'models';
import { AvatarWrapper, Button, Card, GroupLineIcon } from 'ui';
import { useUser } from 'features/auth';
import { IconDirectMessageButton } from 'features/chat';
import { UserLink } from '../user-link';
import { UserPopover } from '../user-popover';

type P = {
  isLoading: boolean;
  onClick: () => void;
  title: string;
  users: UserList[];
  usersTotal: number;
};

const UsersHorizontalScrollCard = ({ isLoading, onClick, title, users, usersTotal }: P) => {
  const { railsUserData: viewer } = useUser();

  return (
    <Card
      extra={
        usersTotal > 10 ? (
          <Button onClick={onClick} type="link-primary">
            See all
          </Button>
        ) : undefined
      }
      title={<Card.Title icon={<GroupLineIcon />}>{title}</Card.Title>}
    >
      {isLoading ? (
        <Card.HorizontalScroll.EntitySkeleton />
      ) : (
        <Card.HorizontalScroll
          items={users.map((user) => ({
            content: (
              <UserPopover user={user}>
                <UserLink userId={user.id}>
                  <AvatarWrapper
                    avatar={{ photo: user.profilePhoto?.url }}
                    extra={<IconDirectMessageButton legacyUserId={user.id} />}
                    user={{ isViewer: user.id === viewer.id, name: getUserName(user) }}
                  />
                </UserLink>
              </UserPopover>
            ),
            key: user.id,
          }))}
        />
      )}
    </Card>
  );
};

export default UsersHorizontalScrollCard;
